interface JsonContent {
  [key: string]: {
    links: any;
    data: any;
  }
}

interface JsonObject {
  content: JsonContent;
  [key: string]: any;
}

interface ValueByRef {
  [key: string]: any;
}

const getValueByRef = (jsonObj: JsonObject, refs: string[]): ValueByRef => {
  const refKeys = refs.map(ref => ref.replace('/content/', ''));
  const finalValuesByRef: ValueByRef = {};

  refKeys.forEach((key) => {
    const defaultKey = key.split(':')[0];
    const customKey = key.split(':')[1];
    const value = jsonObj.content[defaultKey];

    if (value) {
      if (value?.data?.name !== "global-settings") {
        if(value?.data?.original) {
          finalValuesByRef[customKey ?? value?.data?.name] = {
            desktop: value?.data?.original?.links?.site?.href,
            thumbnail: value?.data?.thumbnail?.links?.site?.href,
            mobile: value?.data?.thumbnail?.links?.site?.href.replace('thumbnail', 'banner'),
            alt: value?.data?.displayName
          }
        } else if (value?.links?.site?.href) {
          finalValuesByRef[customKey ?? value?.data?.name] = value?.links?.site?.href;
        } else if(value?.data.color){
          finalValuesByRef[customKey ?? value?.data?.name] = value?.data?.color?.background?.selectionValues[0]?.key;
        } else {
          finalValuesByRef[customKey ?? value?.data?.name] = value?.data;
        }
      }
    }
  });

  return finalValuesByRef;
};

const manuallyPushRefs = (refs: string[], key: string, obj: any) => {
  if(key === 'minicartempty') {
    refs.push(`${obj[key]?.image?.$ref}:minicartemptyImage`);
  }
}

export default function resolveAllJsonRefs(json: JsonObject): ValueByRef {
  const refs: string[] = [];

  const traverse = (obj: any, key?: any) => {
    if (obj && typeof obj === 'object') {
      if ('$ref' in obj) {
        if(key && isNaN(key) && key != 'image') {
          obj['$ref'] += `:${key}`
        }

        refs.push(obj['$ref']);
      }
      for (const key in obj) {
        manuallyPushRefs(refs, key, obj);
        traverse(obj[key], key);
      }
    }
  };

  traverse(json);
  return getValueByRef(json, refs);
}
